import type { App } from "@open-booking/server";
import type { CreateContractPayload } from "@open-booking/shared";
import { createApi } from "@reduxjs/toolkit/query/react";
import { type EdenCall, edenBaseQuery } from "@/src/common/lib/eden-base-query";

type CreateContractResponse = App["~Routes"]["contracts"]["post"]["response"]["200"];
type ContractViewResponse = App["~Routes"]["contracts"][":id"]["view"]["get"]["response"]["200"];
type GenerateContractPdfResponse = App["~Routes"]["contracts"][":id"]["generate-pdf"]["post"]["response"]["200"];

export const contractApi = createApi({
	reducerPath: "contractApi",
	baseQuery: edenBaseQuery(),
	tagTypes: ["Contract"],
	endpoints: (builder) => ({
		createContract: builder.mutation<CreateContractResponse, CreateContractPayload>({
			query:
				(payload): EdenCall<CreateContractResponse> =>
				(client) =>
					client.contracts.post(payload),
		}),
		getContractView: builder.query<ContractViewResponse, string>({
			query:
				(contractId): EdenCall<ContractViewResponse> =>
				(client) =>
					client.contracts({ id: contractId }).view.get(),
			providesTags: (_result, _error, contractId) => [{ type: "Contract", id: contractId }],
		}),
		generateContractPdf: builder.mutation<GenerateContractPdfResponse, string>({
			query:
				(contractId): EdenCall<GenerateContractPdfResponse> =>
				(client) =>
					client.contracts({ id: contractId })["generate-pdf"].post(),
			invalidatesTags: (_result, _error, contractId) => [{ type: "Contract", id: contractId }],
		}),
	}),
});

export const { useCreateContractMutation, useGetContractViewQuery, useGenerateContractPdfMutation } = contractApi;
